import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ContractService } from '../../contract/contract.service';
import { TimesheetService } from '../../ts/timesheet.service';
import { TimesheetParsed, TimesheetStatus } from '../../models/timesheet';
import { UserService } from '../../user.service';
import { Subject, map, tap, takeUntil, filter } from 'rxjs';
import { AppService } from '../../app.service';
import { T7eService } from '../../t7e/t7e.service';
import moment from 'moment';
import { DataService } from '../../data.service';
import { ProductionService } from '../../prod/production.service';
import { config, invoiceMainualLink, POLICIES } from '../../config';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewInit {
  private _destroy$ = new Subject<void>();

  constructor(
    private dataSvc: DataService,
    private prodSvc: ProductionService,
    private contractSvc: ContractService,
    private tsSvc: TimesheetService,
    private userSvc: UserService,
    private appSvc: AppService,
    private cdr: ChangeDetectorRef,
    private t7e: T7eService,
  ) { 
    this.appSvc.pageTitle$.next(this.t7ePageTitle)
    //tsSvc.listTs({})
  }

  get debug() { return this.appSvc.debug }
  get lang() { return this.t7e.lang }
  isTsLoading$ = this.tsSvc.tsListLoading$
  isCrew$ = this.userSvc.isCrew$
  get isDeptAdmin() { return this.userSvc.isDeptAdmin }
  get isOnlyDeptAdmin() { return this.userSvc.isOnlyDeptAdmin }
  get isDeptHead() { return this.userSvc.isDeptHead }
  get isProdMgr() { return this.userSvc.isProdMgr }
  get isMoreThanDeptHead() { return this.userSvc.isMoreThanDeptHead }
  prodTitle = this.prodSvc.prodDefaults?.prname
  appVersionCheckingMessage$ = this.appSvc.appVersionCheckingMessage$
  isAppVersionChecking$ = this.appSvc.isAppVersionChecking$
  invoiceMainualLink = invoiceMainualLink
  trackByIndex = this.appSvc.trackByIndex
  POLICIES = POLICIES
  policyNames = (Object.keys(POLICIES) as (keyof typeof POLICIES)[])
  hasAnyPolicyLink() {
    return Object.values(POLICIES).some(policy => {
      const link = policy[this.lang as keyof typeof policy]?.url
      return link && link.length > 0
    })
  }
  getPolicy(policyName: keyof typeof POLICIES) {
    const policy = POLICIES[policyName]
    const lang = this.lang as keyof typeof policy
    return policy[lang] as { title: string, url: string | null }
  }

  loggedinUser$ = this.userSvc.loggedinUser$
  users$ = this.userSvc.allUsers$
  usersInLoggedInUsersDept$ = this.contractSvc.usersInLoggedInUsersDept$
  pendingUsers$ = this.users$.pipe(map(u => u?.filter(u => u?.ugm?.filter(g => g?.ugid).length === 0).filter(this.contractSvc.hasBasicData)))
  isUsersLoading$ = this.userSvc.allUsersLoading$
  get isProfileComplete() { return this.userSvc.isProfileComplete() }
  isLangSelected = this.userSvc.isLangSelected

  userContracts$ = this.contractSvc.userContracts$
  contracts$ = this.contractSvc.allContracts$
  deptContracts$ = this.contractSvc.deptContracts$
  prodMgrPendingContracts$ = this.contractSvc.prodMgrPendingContracts$
  finalApprovedContracts = this.contractSvc.finalApprovedContracts$
  financePendingContracts$ = this.contractSvc.financePendingContracts$
  readyToSignContracts$ = this.contractSvc.readyToSignContracts$
  atCrewOwnContracts$ = this.contractSvc.atCrewOwnContracts$
  suspiciousContractsLoading$ = this.contractSvc.suspiciousContractsLoading$
  suspiciousContractsProdMgrApproved$ = this.contractSvc.suspiciousContractsProdMgrApproved$
  suspiciousContractsFinanceApproved$ = this.contractSvc.suspiciousContractsFinanceApproved$
  numSuspProdMgrApproved$ = this.contractSvc.suspiciousContractsProdMgrApproved$
    .pipe(
      map(contracts => contracts.length)
    )
  numSuspFinanceApproved$ = this.contractSvc.suspiciousContractsFinanceApproved$
    .pipe(
      map(contracts => contracts.length)
    )
contractsLoading$ = this.contractSvc.allContractsLoading$
  isFinanceApprovalNeededConfig$ = this.contractSvc.isFinanceApprovalNeededConfig$
  CONTRACT_GEN_FEATURE = config.HU.CONTRACT.CONTRACT_GEN_FEATURE
  DEV = config.dev

  tsAtCrew$ = this.tsSvc.ownTsAtCrew$
  deptTsList$ = this.tsSvc.deptTsList$
  pendingProdMgrTimesheets$ = this.tsSvc.tsListBaseWaitingForProdMgr$
  isPendingProdMgrTimesheetsLoading$ = this.tsSvc.isTsListBaseWaitingForProdMgrLoading$
  pendingWTSTimesheets$ = this.tsSvc.tsListBaseWaitingForWTS$
  isPendingWTSTimesheetsLoading$ = this.tsSvc.isTsListBaseWaitingForWTSLoading$
  get pendingOwnTimesheets() { return this.tsSvc.ownTsList$.value?.filter(ts => ts?.tsstatus == TimesheetStatus.attSent) }
  get tsList() { return this.tsSvc.ownTsList$.value?.filter(ts => ts.tsstatus! > 0) }
  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    // ez azért kell, mert refresh után nem frissül a dashboard
    this.dataSvc.initData$
      .pipe(takeUntil(this._destroy$))
      .subscribe((_) => {
        this.cdr.detectChanges()
        this.reloadSuspiciousContracts()
      })
    // setTimeout: enélkül changed after checked error van, mert a TimesheetService.isPendingProdMgrTimesheetsLoading$ false-ról true-ra változik
    setTimeout(() => this.reloadTs(), 0)
  }

  reloadAppData(e?: MouseEvent) {
    e?.stopPropagation();
    this.dataSvc.getAppData()
  }

  reloadUser(e?: MouseEvent) {
    e?.stopPropagation()
    this.reloadCon() // azért kell, mert az, hogy a user pending-e, attól is függ, hogy van-e hozzá contract
    this.userSvc.listUsers()
      .pipe(takeUntil(this._destroy$))
      .subscribe((_) => {
        this.cdr.detectChanges()
      })
  }

  reloadTs(e?: MouseEvent) {
    e?.stopPropagation()
    this.tsSvc.fetchTsBaseWaiting()
  }
  reloadCon(e?: MouseEvent) {
    e?.stopPropagation()
    this.contractSvc.listContracts({}).subscribe({
      next: () => {
        this.reloadSuspiciousContracts()
      }
    })
  }
  reloadSuspiciousContracts(e?: MouseEvent) {
    e?.stopPropagation()
    this.contractSvc.listSuspiciousContracts()
      .pipe(takeUntil(this._destroy$))
      .subscribe((contracts) => {
        console.log('gyanús sf:',contracts)
      })
  }

  getTSDate(ts?: TimesheetParsed | null): string | undefined {
    return ts
      ? moment(ts?.dStartDate).locale('hu').format('M/DD')
      : undefined
  }

  checkForAppUpdates(ev: MouseEvent) {
    ev.stopPropagation()
    this.appSvc.checkForAppUpdate()
  }

  t7ePageTitle = this.t7e.getTranslation('app-dashboard', 'page-title', 'innerText', null, null, 'Főoldal')

  t7eCongratsTitle = this.t7e.getTranslation('app-dashboard', 'congrats-you-are-in', 'title', null)
  t7eCongratsDescr = this.t7e.getTranslation('app-dashboard', 'congrats-you-are-in', 'description', null)

  t7eSectionYourData = this.t7e.getTranslation('app-dashboard', 'section-your-data', 'title', null)
  t7eSectionDeptData = this.t7e.getTranslation('app-dashboard', 'section-dept-data', 'title', null)
  t7eSectionProduction = this.t7e.getTranslation('app-dashboard', 'section-production', 'title', null)
  t7eSectionFinance = this.t7e.getTranslation('app-dashboard', 'section-finance', 'title', null)
  t7eSectionReports = this.t7e.getTranslation('app-dashboard', 'section-reports', 'title', null)

  t7eYouHave = this.t7e.getTranslation('app-dashboard', 'you-have', 'innerText', null)
  t7eYouHaveXContracts = this.t7e.getTranslation('app-dashboard', 'you-have-x-contracts', 'innerText', null)

  t7eProfileIncompleteTitle = this.t7e.getTranslation('app-dashboard', 'box-profile-complete-your-profile', 'innerText', null)

  t7eContractsAtCrewTitle = this.t7e.getTranslation('app-dashboard', 'box-contracts-at-crew', 'title', null)
  t7eTsAtCrewTitle = this.t7e.getTranslation('app-dashboard', 'box-ts-at-crew', 'title', null)
}
